import { render } from "./flipper.vue?vue&type=template&id=50686e85"
import script from "./flipper.vue?vue&type=script&lang=js"
export * from "./flipper.vue?vue&type=script&lang=js"

import "./flipper.vue?vue&type=style&index=0&id=50686e85&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__